import Grid from "@mui/material/Grid";
import MDBox from "../MDBox";
import DashboardLayout from "../examples/LayoutContainers/DashboardLayout/index";
import DashboardNavbar from "../examples/Navbars/DashboardNavbar";
import ComplexStatisticsCard from "../examples/Cards/StatisticsCards/ComplexStatisticsCard";
import BookmarksOutlinedIcon from '@mui/icons-material/BookmarksOutlined';
import React,{Component} from 'react'
import Button from '@material-ui/core/Button';
import Card from "@mui/material/Card";
import Menu from "@mui/material/Menu";
import MDTypography from "../MDTypography";
import TextField from '@mui/material/TextField';
import FormControl from '@material-ui/core/FormControl';
import TimelineItem from "../examples/Timeline/TimelineItem/index";
import InboxOutlinedIcon from '@mui/icons-material/InboxOutlined';
import StorefrontIcon from '@mui/icons-material/Storefront';
import SupervisorAccountOutlinedIcon from '@mui/icons-material/SupervisorAccountOutlined';
import Box from '@mui/material/Box';
import Select from '@atlaskit/select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import ReactDOM from 'react-dom';
import Input from '@material-ui/core/Input';
import Checkbox from '@material-ui/core/Checkbox';
import ListItemText from '@material-ui/core/ListItemText';
import { CheckboxSelect } from '@atlaskit/select';
import Textfield from '@atlaskit/textfield';
import FormControlLabel from '@mui/material/FormControlLabel';
import Modal, {
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalTitle,
  ModalTransition,
} from '@atlaskit/modal-dialog';
import { getSessionId, getToken,removeUserSession } from "../../util";
export default class DashBoard extends Component{
  constructor(){
    super()
    this.state={
      email:'',
      productCode:'',
      productName:'',
      productmodule:'',
      supportpin:'',
      NoofSytem:'',
      NoofMobileUser:'',
      cusEmail:'',
      companyname:'',
      mobilenumber:'',
      labelWidth:0,
      moduleCode:'',
      moduleName:'',
      moduleData:[],
      productData:[],
      softwarename:'',
      modelOpen:false,
      updateModel:'',
      license:'',
      companyName:'',
      companyAddress:'',
      city:'',
      state:0,
      pinCode:'',
      gstNo:'',
      panNo:'',
      useractive:false,
      MenuProps : {
      PaperProps: {
        style: {
          maxHeight: 48 * 4.5 + 8,
          width: 250,
        },
      },
    }
    }
  }
  componentDidMount=()=>{
    
    this.onProductGet()
  }
  onUpdateModel=()=>{
    this.setState({updateModel:true})
  }
  onClose=()=>{
    this.setState({updateModel:false,email:'', productCode:'',productName:'',productmodule:'',supportpin:'', NoofSytem:'',NoofMobileUser:'',
    cusEmail:'',companyname:'', mobilenumber:'',labelWidth:0,moduleCode:'',moduleName:'',softwarename:'', companyName:'',companyAddress:'',
    city:'',state:'',pinCode:'',gstNo:'',panNo:'',license:''})
  }
  onModelClick=()=>{
    this.setState({modelOpen:true})
  }
  onModelCose=()=>{
    this.setState({modelOpen:false,email:'', productCode:'',productName:'',productmodule:'',supportpin:'', NoofSytem:'',NoofMobileUser:'',
    cusEmail:'',companyname:'', mobilenumber:'',labelWidth:0,moduleCode:'',moduleName:'',softwarename:'', companyName:'', companyAddress:'',
    city:'',state:'', pinCode:'',gstNo:'',panNo:'',})
  }
  onProductChange=(data)=>{
   this.setState({productCode:data,productName:data.productname})
   this.onProductModule(data.value)
  } 
  onModuleChange=(data)=>{
    this.setState({moduleCode:data,moduleName:data.moduleName})
  }
  validateEmail=(email)=> {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }
  onDetailsLoad=(emailId)=>{
    if(this.state.email===''){
      alert('Plz Enter EmailID')
    }else if(!this.validateEmail(this.state.email)){
      alert('Plz Enter Valid Email')
      this.setState({productCode:'',productName:'',productmodule:'',supportpin:'', NoofSytem:'',NoofMobileUser:'',
      cusEmail:'',companyname:'', mobilenumber:'',labelWidth:0,moduleCode:'',moduleName:'',softwarename:'', companyName:'', companyAddress:'',
      city:'',state:'', pinCode:'',gstNo:'',panNo:'',})
    }
    else{
    fetch(`eadmin/v1/set/get_user_for_admin?emailId=${emailId}` ,{
      method: 'GET',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      "x-access-token":getToken()
      },
    }).then((response) => response.json())
      .then((responseJson) => {
      if(responseJson.status && responseJson.result.length>0){
        this.setState({companyname:responseJson.result[0].companyname,cusEmail:responseJson.result[0].emailid,mobilenumber:responseJson.result[0].mobilenumber})
      }else if(!responseJson.status){
        this.setState({progress:false})
        alert(responseJson.errorMsg)
      }else{
        alert('no record found')
      }
    }).catch((error) => {
      alert(error)
    });
    }
  }
  onProductGet=()=>{
    fetch(`eadmin/v1/set/load_product` ,{
      method: 'GET',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      "x-access-token":getToken()
      },
    }).then((response) => response.json())
    .then((responseJson) => {
    if(responseJson.status && responseJson.result.length>0){
      let array_data=[]
      for(let data of responseJson.result){
        let temp_data={value:data.productcode,label:data.productname,...data}
        array_data.push(temp_data)
      }
      this.setState({productData:array_data})
    }else if(!responseJson.status){
      alert(responseJson.errorMsg)
    }else{
      alert('no record found')
    }
    }).catch((error) => {
      alert(error)
    });
  }
  onProductModule=(productCode)=>{
    fetch(`eadmin/v1/set/load_module?productCode=${productCode}` ,{
      method: 'GET',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      "x-access-token":getToken()
      },
    }).then((response) => response.json())
    .then((responseJson) => {
    if(responseJson.status && responseJson.result.length>0){
      let array_data=[]
      for(let data of responseJson.result){
        let temp_data={value:data.modulecode,label:data.modulename,...data}
          array_data.push(temp_data)
      }
      this.setState({moduleData:array_data})
    }else if(!responseJson.status){
      alert(responseJson.errorMsg)
    }else{
    // alert('no record found')
    }
    }).catch((error) => {
      alert(error)
    });
  }
  onSaveDetails=()=>{
    if(this.state.license!==''){
      this.onUpdateLicense()
    }
    else if(this.state.email===''||this.state.productCode===''||this.state.softwarename===''||this.state.NoofSytem===''||
    this.state.NoofMobileUser===''){
      alert('All Inputs Are Required')
    }
    else{
      let modules=[]
      for(let data of this.state.moduleCode){
        let moduleCodes={moduleCode:data.modulecode}
        modules.push(moduleCodes)
      }
      let json_data={productCode:this.state.productCode.value,productName:this.state.productName,companyName:this.state.companyname,emailId:this.state.email,
      noOfSystem:this.state.NoofSytem, noOfMobileUser:this.state.NoofMobileUser,softwareIdenName:this.state.softwarename,sessionId:getSessionId(),moduleData:modules,
      companyName:this.state.companyName,companyAddress:this.state.companyAddress,companyCity:this.state.city,pinCode:this.state.pinCode,
      gstNo:this.state.gstNo,panNo:this.state.panNo,companyStateCode:this.state.state,disconnect:this.state.useractive?1:0
      }

      fetch(`eadmin/v1/set/save_licence`, {
        method: 'POST',
        headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        "x-access-token":getToken()
      },
      body:(JSON.stringify(json_data)),
      }).then((response) => response.json())
      .then((responseJson) => {
       
        if(responseJson.status){
          this.onModelClick()
        }
        else{
          alert(responseJson.errorMsg)
        }
      }).catch((error) => {
        alert(error)
      });
    }
  }
  getLicenseDetails=(license)=>{
    if(this.state.license===''){
      alert('Plz Enter LicenseId')
    }else{
      fetch(`eadmin/v1/set/get_licence_details?license=${license}` ,{
      method: 'GET',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      "x-access-token":getToken()
      },
      }).then((response) => response.json())
      .then((responseJson) => {
        let modules=[]
      if(responseJson.status && responseJson.result.length>0){
        this.onProductModule(responseJson.result[0].productcode)
        this.setState({softwarename:responseJson.result[0].softwareidentificationname,email:responseJson.result[0].emailid,NoofSytem:responseJson.result[0].noofsystem,
        NoofMobileUser:responseJson.result[0].noofmobileuser,productCode:{"label":responseJson.result[0].softwarename,"value":responseJson.result[0].productcode},
        companyname:responseJson.result[0].companyname,cusEmail:responseJson.result[0].emailid,mobilenumber:responseJson.result[0].phonenumber,supportpin:responseJson.result[0].supportpin
        ,companyName:responseJson.result[0].companyname,companyAddress:responseJson.result[0].companyaddress,city:responseJson.result[0].companycity,state:responseJson.result[0].companystatecode,
        pinCode:responseJson.result[0].pincode,gstNo:responseJson.result[0].companygstno,panNo:responseJson.result[0].companypanno})
       
        for(let i=0;i<responseJson.result.length;i++){
          let temp_data={"label":responseJson.result[i].modulename,"value":responseJson.result[i].modulecode}
          modules.push(temp_data)
        }
        this.setState({moduleCode:modules})
      
      }else if(!responseJson.status){
        alert(responseJson.errorMsg)
      }else{
        alert('no record found')
      }
      }).catch((error) => {
        alert(error)
      });
    }
  }
  onUpdateLicense=()=>{
    if(this.state.email===''||this.state.productCode===''||this.state.softwarename===''||this.state.NoofSytem===''||
      this.state.NoofMobileUser===''||this.state.license===''){
      alert('All Inputs Are Required')
    }
    else{
      let modules=[]
      for(let data of this.state.moduleCode){
        let moduleCodes={moduleCode:data.value,productCode:this.state.productCode.value}
        modules.push(moduleCodes)
      }
    
      let json_data={productKey:this.state.license,emailId:this.state.email,noOfSystem:this.state.NoofSytem,noOfMobileUser:this.state.NoofMobileUser,softwareIdenName:this.state.softwarename,
      sessionId:getSessionId(),moduleData:modules,supportPin:this.state.supportpin,companyName:this.state.companyName, companyAddress:this.state.companyAddress, companyCity:this.state.city,
      companyStateCode:this.state.state,pinCode:this.state.pinCode, gstNo:this.state.gstNo,panNo:this.state.panNo,disconnect:this.state.useractive?1:0	
      }
 
      fetch(`eadmin/v1/set/update_licence`, {
        method: 'POST',
        headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        "x-access-token":getToken()
        },
        body:(JSON.stringify(json_data)),
      }).then((response) => response.json())
      .then((responseJson) => {
        if(responseJson.status){
          this.onUpdateModel()
        } 
        else{
          alert(responseJson.errorMsg)
        }
      }).catch((error) => {
        alert(error)
      });
    }
  }
  render() {
    return (
      <>
         <DashboardNavbar />
        <DashboardLayout>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6} lg={8}>
                <MDBox color="text" px={2}>
                  <Grid container>
                    <Grid item md={7}/>
                    <Grid Item md={3}  xs={12} sm={12}>
                      <TextField
                        label="License"
                        margin="normal"
                        variant="outlined"
                        value={this.state.license}
                        onChange={(evt)=>this.setState({license:evt.target.value})}
                      />
                    </Grid>
                    <Grid Item md={2}  xs={12} sm={12}> 
                      <Button variant="contained" color="primary" style={{marginTop:'15%'}} onClick={()=>this.getLicenseDetails(this.state.license)}>Load</Button> </Grid>
                  </Grid>
                </MDBox>
                <Card>
                <MDBox display="flex" justifyContent="space-between" alignItems="center" p={3}>
                  <MDBox>
                    <MDTypography variant="h6" gutterBottom>
                      Details
                    </MDTypography>
                    <MDBox display="flex" alignItems="center" lineHeight={0}>
                      <MDTypography variant="button" fontWeight="regular" color="text">
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                  <MDBox color="text" px={2}>
                    </MDBox>
                  </MDBox>
                  <MDBox>
                  <Grid container>
                    <Grid item md={2}/>
                    <Grid Item md={5}  xs={12} sm={12}>
                      <FormControl sx={{ m:1, width: '100%' }}>
                        <TextField
                          label="User Mail ID *"
                          margin="normal"
                          variant="outlined"
                          style={{fontWeight:800,}}
                          value={this.state.email}
                          onChange={(evt)=>this.setState({email:evt.target.value})}
                        />
                      </FormControl>
                      <FormControl sx={{ m:1, width: '95%' }}>
                        <Button variant="contained" color="primary" style={{marginTop:'26%',marginLeft:'2%'}} onClick={()=>this.onDetailsLoad(this.state.email)}>Load</Button> 
                      </FormControl>
                    </Grid>
                    <Grid Item md={5}  xs={12} sm={12}>
                      <FormControl style={{sx:'2%', minWidth: '45%',paddingTop:'2%' }} size="small">
                        <Select
                          inputId="single-select-example"
                          className="single-select"
                          classNamePrefix="react-select"
                          value={this.state.productCode} options={this.state.productData} onChange={this.onProductChange}
                          placeholder="Product *"
                        />
                      </FormControl>
                    </Grid>
                  </Grid><br/>
                  <Grid container>
                    <Grid item md={2}/>
                    <Grid Item md={5}  xs={12} sm={12}>
                      <FormControl sx={{ m:1, width: '95%' }}>
                        <TextField
                          label="Identification Name *"
                          margin="normal"
                          variant="outlined"
                          value={this.state.softwarename}
                          onChange={(evt)=>this.setState({softwarename:evt.target.value.toUpperCase()})}
                        />
                      </FormControl>
                    </Grid>
                    <Grid Item md={5}  xs={12} sm={12}>
                      <FormControl style={{sx:'2%', minWidth: '45%' }} size="small">
                        <CheckboxSelect
                          inputId="multi-select-example"
                          className="multi-select"
                          classNamePrefix="react-select"
                          value={this.state.moduleCode} options={this.state.moduleData} onChange={this.onModuleChange}
                          style={{fontSize:'5'}}
                          isMulti
                          isSearchable={true}
                          placeholder="Module"
                        />
                      </FormControl>
                    </Grid>
                  </Grid><br/>
                  <Grid container>
                    <Grid item md={2}/>
                    <Grid Item md={5}  xs={12} sm={12}>
                      <FormControl sx={{ m:1, width: '95%' }}>
                        <TextField
                          label="Support PIN"
                          margin="normal"
                          variant="outlined"
                          disabled={true}
                          value={this.state.supportpin}
                        />
                      </FormControl>
                    </Grid>
                    <Grid Item md={5}  xs={12} sm={12}>
                      <FormControl sx={{ m:1, width: '100%' }}>
                        <Textfield
                          placeholder="Number of System*"
                          margin="normal"
                          variant="outlined"
                          value={this.state.NoofSytem}
                          onChange={(evt)=>this.setState({NoofSytem:evt.target.value})}
                        />
                      </FormControl>
                    </Grid>
                  </Grid><br/>
                  <Grid container>
                    <Grid item md={2}/>
                    <Grid Item md={5}  xs={12} sm={12}>
                      <FormControl sx={{ m:1, width: '95%' }}>
                        <TextField
                          label="Number of Mobile User*"
                          margin="normal"
                          variant="outlined"
                          value={this.state.NoofMobileUser}
                          onChange={(evt)=>this.setState({NoofMobileUser:evt.target.value})}
                        />
                      </FormControl>
                    </Grid>
                    <Grid Item md={5}  xs={12} sm={12}>
                      <FormControl sx={{ m:1, width: '95%' }}>
                        <Textfield
                          placeholder="Company Name"
                          margin="normal"
                          variant="outlined"
                          value={this.state.companyName}
                          onChange={(evt)=>this.setState({companyName:evt.target.value.toUpperCase()})}
                        />
                      </FormControl>
                    </Grid>
                  </Grid><br/>
                  <Grid container>
                    <Grid item md={2}/>
                    <Grid Item md={5}  xs={12} sm={12}>
                      <FormControl sx={{ m:1, width: '95%' }}>
                        <TextField
                          label="Company Address"
                          margin="normal"
                          variant="outlined"
                          value={this.state.companyAddress}
                          onChange={(evt)=>this.setState({companyAddress:evt.target.value.toUpperCase()})}
                        />
                      </FormControl>
                    </Grid>
                    <Grid Item md={5}  xs={12} sm={12}>
                      <FormControl sx={{ m:1, width: '95%' }}>
                        <TextField
                          label="City"
                          margin="normal"
                          variant="outlined"
                          value={this.state.city}
                          onChange={(evt)=>this.setState({city:evt.target.value.toUpperCase()})}
                        />
                      </FormControl>
                    </Grid>
                  </Grid><br/>
                  <Grid container>
                    <Grid item md={2}/>
                    <Grid Item md={5}  xs={12} sm={12}>
                      <FormControl sx={{ m:1, width: '95%' }}>
                        <TextField
                          label="State Code"
                          margin="normal"
                          variant="outlined"
                          value={this.state.state}
                          onChange={(evt)=>this.setState({state:evt.target.value})}
                        />
                      </FormControl>
                    </Grid>
                    <Grid Item md={5}  xs={12} sm={12}>
                      <FormControl sx={{ m:1, width: '95%' }}>
                        <TextField
                          label="PinCode"
                          margin="normal"
                          variant="outlined"
                          value={this.state.pinCode}
                          onChange={(evt)=>this.setState({pinCode:evt.target.value})}
                        />
                      </FormControl>
                    </Grid>
                  </Grid><br/>
                  <Grid container>
                    <Grid item md={2}/>
                    <Grid Item md={5}  xs={12} sm={12}>
                      <FormControl sx={{ m:1, width: '95%' }}>
                        <TextField
                          label="PAN NO"
                          margin="normal"
                          variant="outlined"
                          value={this.state.panNo}
                          onChange={(evt)=>this.setState({panNo:evt.target.value.toUpperCase()})}
                        />
                      </FormControl>
                    </Grid>
                    <Grid Item md={5}  xs={12} sm={12}>
                      <FormControl sx={{ m:1, width: '95%' }}>
                        <TextField
                          label="GST NO"
                          margin="normal"
                          variant="outlined"
                          value={this.state.gstNo}
                          onChange={(evt)=>this.setState({gstNo:evt.target.value.toUpperCase()})}
                        />
                      </FormControl>
                    </Grid>
                    {/*this.state.license!=='' && (*/}
                       <React.Fragment>
                    <Grid item xs={12} sm={12} md={2}/>
                    <Grid item xs={12} sm={12} md={4}>
              <FormControlLabel control={<Checkbox  style={{color:'#4A148C',marginLeft:'15px'}} />} label="DISCONNECT" checked={this.state.useractive} onChange={()=>this.setState({useractive:!this.state.useractive})} />
               </Grid>
               </React.Fragment>
                    {/* )*/}
                  </Grid><br/>
              <center><Button variant="contained" color="primary" onClick={this.onSaveDetails}> Save</Button></center>
            </MDBox><br/>
            </Card>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <Card sx={{ height: "100%" }}>
              <MDBox pt={3} px={3}>
                <MDTypography variant="h6" fontWeight="medium">
                  Customer Details
                </MDTypography>
                <MDBox mt={0} mb={2}>
                  <MDTypography variant="button" color="text" fontWeight="regular">
                    <MDTypography display="inline" variant="body2" verticalAlign="middle">
                    </MDTypography>
                    &nbsp;
                  </MDTypography>
                </MDBox>
              </MDBox>
              <MDBox p={1}>
                <Grid container spacing={0.01}>
                  <Grid item xs={1} sm={1} md={1}/>
                  <Grid item xs={3} sm={3} md={3}><p style={{fontSize:15,color:'black'}}>Company Name </p></Grid>
                  <Grid item xs={1} sm={1} md={1}><p>:</p></Grid>
                  <Grid item xs={4} sm={4} md={4}><p style={{fontWeight:'600',fontSize:15}}>{this.state.companyname}</p></Grid>
                  <Grid item xs={3} md={3} sm={3}/>
                  <Grid item xs={1} sm={1} md={1}/>
                  <Grid item xs={3} sm={3} md={3}><p style={{fontSize:15,color:'black'}}>EmailID </p></Grid>
                  <Grid item xs={1} sm={1} md={1}><p>:</p></Grid>
                  <Grid item xs={4} sm={4} md={4}><p style={{fontWeight:'600',fontSize:15}}>{this.state.cusEmail}</p></Grid>
                  <Grid item xs={3} md={3} sm={3}/>
                  <Grid item xs={1} sm={1} md={1}/>
                  <Grid item xs={3} sm={3} md={3}><p style={{fontSize:15,color:'black'}}>Mobile No </p></Grid>
                  <Grid item xs={1} sm={1} md={1}><p>:</p></Grid>
                  <Grid item xs={5} sm={5} md={5}><p style={{fontWeight:'600',fontSize:15}}>{this.state.mobilenumber}</p></Grid>
                  <Grid item xs={2} md={2} sm={2}/>
                </Grid><br/>
              
              </MDBox>
            </Card>
          </Grid>
         
          </Grid>
      
      </DashboardLayout>  
      <ModalTransition>
        {this.state.modelOpen && (
          <Modal onClose={this.onModelCose} >
            <ModalHeader>
              <ModalTitle>ADMIN LICENSE</ModalTitle>
            </ModalHeader>
            <ModalBody>
            <label>SAVED SUCCESSFULLY </label>
            </ModalBody>
            <ModalFooter>
              <Button appearance="primary" onClick={this.onModelCose} autoFocus>
              OK
              </Button>
            </ModalFooter>
          </Modal>
        )}
      </ModalTransition>
      <ModalTransition>
        {this.state.updateModel && (
          <Modal onClose={this.onClose} >
            <ModalHeader>
              <ModalTitle>ADMIN LICENSE</ModalTitle>
            </ModalHeader>
            <ModalBody>
            <label>UPDATE SUCCESSFULLY </label>
            </ModalBody>
            <ModalFooter>
              <Button appearance="primary" onClick={this.onClose} autoFocus> OK </Button>
            </ModalFooter>
          </Modal>
        )}
      </ModalTransition>
    </>
  );
  }
}

